<template>
  <div>
    <h4 class="title">
      {{ $t('myCabinetMenu.sorular') }}
    </h4>
    <div class="card">
      <div class="card-body">
        <div
          class="dashboard-row pointer "
          @click.prevent="$router.push({name: 'requestsByType', params: {type: 'TRK'}})"
        >
          <div class="pr-4">
            <h6 class="">
              {{ $t('logisticDashboard.trElanlar') }}
            </h6>
            <p>
              {{ $t('logisticDashboard.buBlmdPlanladrlanSfrlrinizVMvcudBoYerlBalMlumatVer') }}
            </p>
          </div>
          <div>
            <span :class="`badge ${dashboardResponse.trk.length > 0 ? 'bg-danger' : 'badge-light'}`">
              {{ $t('logisticDashboard.soruVar', {length: dashboardResponse.trk.length}) }}</span>
          </div>
        </div>
        <hr>
        <div
          class="dashboard-row pointer "
          @click.prevent="$router.push({name: 'requestsByType', params: {type: 'TRS'}})"
        >
          <div class="pr-4">
            <h6 class="">
              {{ $t('logisticDashboard.trAxtarSorular') }}
            </h6>
            <p>
              {{ $t('logisticDashboard.buBlmdLogistikaIrktlriTrfindnYerldirilmiTrAxtarSor') }}
            </p>
          </div>
          <div>
            <span :class="`badge ${dashboardResponse.trs.length > 0 ? 'bg-danger' : 'badge-light'}`">
              {{ $t('logisticDashboard.soruVar', {length: dashboardResponse.trs.length}) }}</span>
          </div>
        </div>
        <hr>
        <div
          class="dashboard-row pointer "
          @click.prevent="$router.push({name: 'requestsByType', params: {type: 'LGI'}})"
        >
          <div class="pr-4">
            <h6 class="">
              {{ $t('logisticDashboard.logistikInformasiyaSorular') }}
            </h6>
            <p>
              {{ $t('logisticDashboard.buBlmdLogistikaIlBalInformasiyaSorularnIzlyBilrsin') }}
            </p>
          </div>
          <div>
            <span :class="`badge ${dashboardResponse.lgi.length > 0 ? 'bg-danger' : 'badge-light'}`">
              {{ $t('logisticDashboard.soruVar', {length: dashboardResponse.lgi.length}) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'TruckDashboard',
  props: {
    CompanyProfileType: {},
    dashboardResponse: {},
  },
  computed: {

    ...mapState({
      profile: state => state.auth.profile
    })

  }
}
</script>

<style scoped lang="scss">

@import "@/assets/scss/theme/_variables.scss";

.title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 1rem;
}

hr{
  margin: 10px 0;
}

.dashboard-row {
  font-size: 14px;
  display: flex;
  align-items: start;
  justify-content: space-between;
  border-radius: 6px;
  padding: 20px;

  h6 {
    font-size: 16px;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    margin-bottom: 0;
    color: $theme-body-sub-title-color;
  }

  &:hover {
    background-color: rgba(#2062FB, 0.05);
    h6{
      color: #2062FB;
    }
  }
}
</style>
